import { render } from "./MarciModele.vue?vue&type=template&id=6f25316b&scoped=true&ts=true"
import script from "./MarciModele.vue?vue&type=script&lang=ts"
export * from "./MarciModele.vue?vue&type=script&lang=ts"

import "./MarciModele.vue?vue&type=style&index=0&id=6f25316b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f25316b"]])

export default __exports__